import { useSelector } from "react-redux";
import {
  getLeadProvider,
  getNhDealApplicationId,
  getCurrentUserId,
  getInquiryId,
  getLoanPurpose,
  getUserRole,
  getIsCoBorrowerHasOwnNhApplication,
  getIsConsentCollected,
  getApplicationRoleType,
  getNhApplicationStatus,
} from "features/authSlice";
import { LeadProvider, RegistrationRoleType } from "pages/registration/registrationService";
import WelcomeVersonOne from "./WelcomeVOne";
import WelcomeMultiPath from "./WelcomeMultiPath";
import { useEffect } from "react";
import { useGetInterimDashboardQuery, useGetInquiryDataQuery } from "pages/application/applicationService";
import { LoadingOverlay } from "components/ui/loading-spinners";
import { trackOptUserData } from "utilities/optimizely";
import usePerformRouting from "features/PerformRouting";
import InterimWelcomePage from "./InterimWelcomePage";
import { trackFSApplicationStarted } from "utilities/full-story";
import { ApplicationStatusNames } from "utilities/Constant";

export default function Welcome() {
  const leadProvider = useSelector(getLeadProvider);
  const userId = useSelector(getCurrentUserId);
  const id = useSelector(getNhDealApplicationId);
  const inquiryId = useSelector(getInquiryId);
  const loanPurpose = useSelector(getLoanPurpose);
  const userRole = useSelector(getUserRole);
  const applicationRoleType = useSelector(getApplicationRoleType);
  const isCoBorrowerHasOwnNhApplication = useSelector(getIsCoBorrowerHasOwnNhApplication);
  const nhApplicationStatus = useSelector(getNhApplicationStatus);
  const isLPMicrosite = leadProvider ? leadProvider.toLowerCase() == LeadProvider.Microsite.toLowerCase() : false;
  const isNafLink = leadProvider ? leadProvider.toLowerCase() == LeadProvider.NafLink.toLowerCase() : false;
  const { data: hasInterimDashboard, isLoading, isFetching } = useGetInterimDashboardQuery({ id, userId });
  const { data: inquiryData, isLoading: inquiryDataLoading } = useGetInquiryDataQuery(inquiryId);
  const now = new Date();
  const day = String(now.getUTCDate()).padStart(2, "0");
  const month = String(now.getUTCMonth() + 1).padStart(2, "0");
  const year = now.getUTCFullYear();
  const utcDate = `${month}/${day}/${year}`;
  const isConsentCollected = useSelector(getIsConsentCollected);
  const { performRouting } = usePerformRouting();

  const setPath = (path: string) => {
    const transformedPathName = path.charAt(0).toUpperCase() + path.slice(1);
    if (inquiryData) {
      trackOptUserData(inquiryData, loanPurpose, transformedPathName, leadProvider);
    }
    const roleType = (applicationRoleType || "").toLowerCase();
    const userRoleNormalized = (userRole || "").toLowerCase();
    const isSpouse = userRoleNormalized === "spousalcoborrower" || userRoleNormalized === "spouse";
    const borrowerType = isSpouse ? "Spouse" : roleType === "nonspousalcoborrower" || roleType === "2" ? "NSCB" : "Primary";
    trackFSApplicationStarted({
      leadProvider,
      loanType: loanPurpose,
      pathSelected: transformedPathName,
      applicationStartedDate: utcDate,
      leadCampaign: inquiryData?.leadCampaign,
      loanOfficerAssigned: inquiryData?.loanOfficerAssigned,
      borrowerType: borrowerType,
    });
  };
  useEffect(() => {
    performRouting();
  }, []);
  if (isLoading || isFetching || inquiryDataLoading) {
    return <LoadingOverlay />;
  }
  const isSpouseWithApplication = userRole.toLowerCase() === RegistrationRoleType.SpousalCoBorrower.toLowerCase() && isCoBorrowerHasOwnNhApplication;
  return (
    <>
      {!isConsentCollected && (hasInterimDashboard || nhApplicationStatus.toLowerCase() == ApplicationStatusNames.InProgress.toLowerCase()) ? (
        <InterimWelcomePage isRedirectToDashboard={hasInterimDashboard ?? false} />
      ) : isLPMicrosite || isSpouseWithApplication || isNafLink ? (
        <WelcomeVersonOne setPath={setPath} />
      ) : (
        <WelcomeMultiPath setPath={setPath} />
      )}
    </>
  );
}
